let dataLayer = {}

export function addtoDataLayer(key, data) {
  dataLayer = { ...dataLayer, [key]: data }
}

export function removefromDataLayer(key) {
  if (dataLayer && key) {
    delete dataLayer[key]
  }
}

/**
 * Added as part of portability.
 * When a module directly accessed window.dataLayer,
 * it has been replaced with this.
 */
export function getDataLayer() {
  return dataLayer
}
